import styled from 'styled-components';

export const FormSubmitContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin: 40px 0 0;
`;

export const FormInputContainer = styled.div`
    margin: 40px 0 0;

    &.mr50 {
        margin-right: 50% !important;
    }
    &.ml50 {
        margin-left: 50% !important;
    }

    .label {
        cursor: pointer;
        display: block;
        font-weight: ${props => props.theme.boldWeight};
        margin: -20px 0 20px;
    }
    .justify {
        display: flex;
        justify-content: space-between;
    }

    .item {
        width: 100%;
        height: 52px;

        &.item-textarea,
        &.item-file,
        &.item-legend {
            height: auto;
        }
        &.item-file {
            position: relative;

            .file-hint {
                line-height: 2;
            }
        }
    }
    textarea.input {
        margin: 0;
    }
    /* version inline label+input pour les radios et checkboxs */
    .item-wrapper-box-input {
        height: auto;
    }
    .item-wrapper-box-input .label {
        margin: 0 20px 0 0;
    }
    .item-wrapper-box-input .item {
        width: auto;
        height: auto;
    }
    /* checkbox/radio perso */
    .option-box-input {
        margin-left: 30px;
        &:first-child {
            margin: 0;
        }
    }
    input[type='radio'].box-input,
    input[type='checkbox'].box-input {
        opacity: 0;
        position: absolute;
        left: 0;
    }
    input[type='radio'].box-input + label,
    input[type='checkbox'].box-input + label {
        flex-wrap: nowrap;
        margin: 0;
    }
    input[type='radio'].box-input + label:before,
    input[type='checkbox'].box-input + label:before {
        content: '';
        display: block;
        float: left;
        width: 14px;
        height: 14px;
        border: 1px solid ${props => props.theme.checkboxRadioBorderColor};
        background: ${props => props.theme.checkboxRadioBackgroundColor};
        margin: 0 15px 0 0;
        -webkit-transition: background ease-in-out 0.2s;
        transition: background ease-in-out 0.2s;
        flex: 0 0 auto;
    }
    input[type='radio'].box-input:checked + label:before,
    input[type='checkbox'].box-input:checked + label:before {
        background: url('#{$static-root}/check.svg') no-repeat transparent;
    }
    /* box avec border et coche noir */
    input[type='radio'].box-input.box-input-b + label:before,
    input[type='checkbox'].box-input.box-input-b + label:before {
        border-color: ${props => props.theme.checkboxRadioBorderColor};
    }
    input[type='radio'].box-input.box-input-b:checked + label:before,
    input[type='checkbox'].box-input.box-input-b:checked + label:before {
        background-image: url('#{$static-root}/check.svg');
    }
    /* box XL avec border et coche gris */
    input[type='radio'].box-input.box-input-g-xl + label:before,
    input[type='checkbox'].box-input.box-input-g-xl + label:before {
        border: 1px solid ${props => props.theme.checkboxRadioBorderColor};
        border-radius: 3px;
        height: 29px;
        width: 29px;
    }
    input[type='radio'].box-input.box-input-g-xl:checked + label:before,
    input[type='checkbox'].box-input.box-input-g-xl:checked + label:before {
        background-image: url('#{$static-root}/check.svg');
        background-position: 4px 6px;
        background-size: 73%;
    }
    input[type='radio'].box-input + label:before,
    input[type='checkbox'].box-input + label:before {
        display: inline-block;
        float: none;
        margin-bottom: 0;
    }

    /* input file */
    /* file list */
    .files {
        list-style: none;
        padding: 0;
        .file {
            background-color: ${props => props.theme.fileBackgroundColor};
            padding: 5px 10px;
            font-size: 12px;
            line-height: 1.5;
            margin: 5px 10px 0 0;
            button {
                margin: 0 0 0 10px;
                background: none;
                border: none;
                cursor: pointer;
            }
        }
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        &.mr50 {
            margin-right: 0 !important;
        }
    }

    .input {
        height: 100%;
        color: ${props => props.theme.colorText};
        border: 1px solid ${props => props.theme.inputBorderColor};
        padding: 10px;
        width: 100%;
        &.input-select,
        &.input-file {
            border: none;
        }
        &.input-file {
            opacity: 0;
            position: absolute;
            top: 0;
            left: 0;
            z-index: -1;
            padding: 0;
            width: auto;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/form/FormComponentStyle.js